// Console V0.1.141; V1.16.32 customer access; 2026-10-09 01:56 CST; parent f4950b06d79d73b88b5515e22ad3015189c67c2b.
// Console delegation V1.0; 2026-10-07 09:05:47 CST; parent dcebd36069b2ddb3e45e586f2c90a0214b9a2a4f.
import type { TokenStorage } from '@hotx-cdn/shared';
const KEY = 'hotx-cdn:console:delegation';
export interface DelegationSession {
  sessionToken: string;
  customerId: number;
  customerName: string;
  operatorName: string;
  expiresAt: number;
  expiresIn?: number;
}
export function inDelegationContext() { return sessionStorage.getItem(KEY) !== null; }
export function readDelegation(): DelegationSession | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return value && typeof value.sessionToken === 'string' && /^[A-Za-z0-9_-]{43}$/.test(value.sessionToken)
      && Number.isSafeInteger(value.customerId) && value.customerId > 0 && Number.isFinite(value.expiresAt)
      ? value : null;
  } catch { return null; }
}
export function saveDelegation(value: Omit<DelegationSession, 'expiresAt'> & { expiresIn: number }) {
  if (!value || !/^[A-Za-z0-9_-]{43}$/.test(value.sessionToken) || !Number.isSafeInteger(value.customerId)
    || value.customerId <= 0 || !Number.isFinite(value.expiresIn) || value.expiresIn <= 0 || value.expiresIn > 18000) {
    throw new Error('客户代理身份无效，请从后台重新进入。');
  }
  sessionStorage.setItem(KEY, JSON.stringify({ ...value, expiresAt: Date.now() + value.expiresIn * 1000 }));
}
export function endDelegation() {
  // Retain a tab-local marker: never silently reveal the ordinary customer's stored session.
  sessionStorage.setItem(KEY, JSON.stringify({ ended: true }));
}
export function createDelegatedStorage(base: TokenStorage): TokenStorage {
  return {
    save(token) { sessionStorage.removeItem(KEY); base.save(token); },
    getAccessToken: () => inDelegationContext() ? readDelegation()?.sessionToken ?? null : base.getAccessToken(),
    getRefreshToken: () => inDelegationContext() ? null : base.getRefreshToken(),
    getCustomerId: () => inDelegationContext() ? readDelegation()?.customerId ?? null : base.getCustomerId(),
    getMustChangePassword: () => inDelegationContext() ? false : base.getMustChangePassword(),
    clear() { if (inDelegationContext()) endDelegation(); else base.clear(); }
  };
}
